export default __webpack_public_path__ + "static/uaes1-c70b52bd05177f3c71d3f95c237a92f8.png";